import 'jquery-ujs'

// import _ from 'underscore'
// import * as d3 from 'd3'
// import ko from 'knockout'
import './polyfill'

import 'bootstrap/dist/js/bootstrap'
// import bootbox from 'bootbox'
import 'chosen-js/chosen.jquery'
import 'eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min'

import "../stylesheets/application.css"

$.rails.allowAction = function(link){
  if (link.data("confirm") == undefined){
    return true;
  }
  $.rails.showConfirmationDialog(link);
  return false;
}
//User click confirm button
$.rails.confirmed = function(link){
  link.data("confirm", null);
  link.trigger("click.rails");
}
//Display the confirmation dialog
$.rails.showConfirmationDialog = function(link){
  var message = link.data("confirm");
  bootbox.confirm(message, function(result){
    if (result) {
      $.rails.confirmed(link);
    }
  });
}
